import { relationshipModel, serviceModel } from '~/models';
import { COBStep, getCommonReachableSteps } from '../ClientOnboarding.common.utils';
import { Reason } from '../ClientOnboarding.utils';
export function hasAtLeastOneServiceCommitted(relationship, selectedBundleId, selectedOptionalServices) {
    return relationshipModel.actualServices(relationship, selectedBundleId).some((service)=>serviceModel.isMandatory(service.participation) || selectedOptionalServices.includes(service.id));
}
export function computeApproveDisabledReason(args) {
    const isOnSignAndApprove = args.currentStep === COBStep.signAndApprove;
    if (args.isReviewer && isOnSignAndApprove) return Reason.ReviewerApprove;
    if (args.isPreview) return undefined;
    if (!args.isAllowedToSign && isOnSignAndApprove) return Reason.NotAllowedToSign;
    if (args.hasPaymentMethod && !args.hasSelectedFundingSource) return Reason.PaymentMethod;
    if (args.relationship.serviceBundles != null && args.selectedBundleId == null) return Reason.SelectAPackage;
    if (args.hasUnacceptedStatements) return Reason.ApproveTermsOfServices;
    if (!hasAtLeastOneServiceCommitted(args.relationship, args.selectedBundleId, args.selectedOptionalServices)) {
        return Reason.ReviewServices;
    }
    return undefined;
}
export const nextStepButtonTextsPath = 'clientFlow';
export function getVendorGradientStyle(branding) {
    return {
        background: "linear-gradient(315deg, var(--bg-gradient-color-2, ".concat(branding.backgroundGradientEnd, ") 0%, var(--bg-gradient-color-1, ").concat(branding.backgroundGradientStart, ") 100%)")
    };
}
export function getReachableInnerSteps(relationship) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return [
        COBStep.introduction,
        ...getCommonReachableSteps(relationship, options),
        COBStep.signAndApprove,
        COBStep.allSet
    ];
}
export function getNextStepButtonText(step, relationship, texts) {
    let options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const reachableSteps = getReachableInnerSteps(relationship, options);
    const currentStepIndex = reachableSteps.indexOf(step);
    if (currentStepIndex === -1) {
        return texts.footer.next();
    }
    if (step === COBStep.signAndApprove) {
        return texts.footer.approveAgreement();
    }
    const nextStep = reachableSteps[currentStepIndex + 1];
    if (!nextStep) {
        return texts.footer.approveAgreement();
    }
    if (nextStep === COBStep.selectAPackage) {
        return texts.steps.selectAPackage();
    }
    return texts.footer.next();
}
